import React from 'react'
import { CrossClientNeedsActionElement } from '../NeedsAction/CrossClientNeedsActionElement'
import { type CrossClientCompletedResult } from './useCrossClientCompleted'
import { CrossClientRowSkeleton } from '../CrossClientRowSkeleton'
import { CrossClientEmptyState } from '../CrossClientEmptyState'
import { Button } from '../../../../components/Button/Button'

interface CrossClientCompletedProps {
  completed: CrossClientCompletedResult
}

export const CrossClientCompleted: React.FC<CrossClientCompletedProps> = ({ completed }) => {
  const { executions, hasMore, loadingMore, showMore, loading } = completed

  if (loading) {
    return <CrossClientRowSkeleton count={3} />
  }

  if (!executions.length) {
    return <CrossClientEmptyState message='No completed queries yet' />
  }

  return (
    <div className='d-flex flex-column gap-2 w-100'>
      {executions.map((execution) => (
        <CrossClientNeedsActionElement key={execution.id} execution={execution} variant='completed' />
      ))}
      {hasMore ? (
        <Button variant='header' className='button-small zocks-border-0.5 align-self-center' loading={loadingMore} onClick={showMore}>
          Show more…
        </Button>
      ) : null}
    </div>
  )
}
